<template>
  <div class="tabset">
    <ul class="tabset__nav" role="tablist" ref="tabsetNav">
      <a
        class="tabset__tab"
        v-for="tab in tabs"
        :key="tab.href"
        :class="{ 'tabset__tab--active': tab.active }"
        :href="tab.href"
        role="tab"
        @click="selectTab(tab)"
      >
        {{ tab.header }}
      </a>
    </ul>
    <div class="tabset__content" :style="{ height: panelHeight + 'px' }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { ref, reactive, provide, onMounted, onUnmounted } from "vue";
import $ from "jquery";

export default {
  props: {
    sticky: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const tabs = reactive([]);
    const panelHeight = ref(0);
    const tabsetNav = ref(null);

    // Fournir une méthode pour enregistrer les tabs
    provide("registerTab", (tab) => {
      tabs.push(tab);
    });

    const selectTab = (selectedTab) => {
      tabs.forEach(tab => {
        if (tab.href === selectedTab.href) {
          tab.active = true;
          panelHeight.value = tab.el.clientHeight;
        } else {
          tab.active = false;
        }
      });
    };

    const setSticky = () => {
      const $stick = $(tabsetNav.value);
      const top = $stick.offset().top;
      const isMobile = document.documentElement.clientWidth < 768;
      const offset = !isMobile ? 41 : 0;

      $(window).on("scroll", () => {
        const topNavHeight = $(".region-navigation").height() + $(".region-header").height();
        const st = $(window).scrollTop();
        if (top - st - topNavHeight <= 0) {
          $stick.addClass("stick").css({ top: topNavHeight + "px" });
          $stick.next().css({ marginTop: $stick.height() + "px" });
        } else {
          $stick.removeClass("stick").removeAttr("style");
          $stick.next().css({ marginTop: "inherit" });
        }
      });
    };

    onMounted(() => {
      if (tabs.length > 0) {
        selectTab(tabs[0]);
      }
      setSticky();
    });

    onUnmounted(() => {
      $(window).off("scroll");
    });

    return {
      tabs,
      panelHeight,
      selectTab,
      tabsetNav
    };
  }
};
</script>

<style lang="sass" src="./tabset.sass"></style>
